<template>
  <div>人伤直赔列表</div>
</template>

<script>
export default {
name:'',
data(){
return {};
}
};

</script>
<style  lang="scss" scoped>
</style>